import { useEffect } from 'react';

import { appConfig } from '@/config/app.config';

/** Sets `document.title` to "<title> · Club29" for as long as the component is mounted. */
export function useDocumentTitle(title: string): void {
  useEffect(() => {
    const previous = document.title;
    document.title = title ? `${title} · ${appConfig.app.name}` : appConfig.app.name;
    return () => {
      document.title = previous;
    };
  }, [title]);
}
